export default __webpack_public_path__ + "static/media/RU.47d0fe6d.svg";